import { getPwaUi } from "../i18n/pwaUi.js";
import type { Locale } from "../../../src/index.js";

export interface SettingsViewContext {
  email: string;
  locale: Locale;
  gmName: string;
  subjectName: string;
  onBackHome: () => void;
  onDeleteAccountClick: () => void;
}

function esc(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function mountSettingsView(root: HTMLElement, ctx: SettingsViewContext): void {
  const ui = getPwaUi(ctx.locale);

  root.innerHTML = `
    <div class="settings">
      <header class="settings-header">
        <h1>${esc(ui.settingsTitle)}</h1>
        <button type="button" class="settings-back btn-secondary">${esc(ui.settingsBackToHome)}</button>
      </header>

      <section class="settings-card">
        <h2>${esc(ui.settingsProfile)}</h2>
        <dl class="settings-kv">
          <dt>${esc(ui.settingsEmailLabel)}</dt><dd>${esc(ctx.email)}</dd>
          <dt>${esc(ui.settingsLocaleLabel)}</dt><dd>${esc(ctx.locale)}</dd>
          <dt>${esc(ui.settingsGameMasterLabel)}</dt><dd>${esc(ctx.gmName)}</dd>
          <dt>${esc(ui.settingsSubjectLabel)}</dt><dd>${esc(ctx.subjectName)}</dd>
        </dl>
      </section>

      <section class="settings-card danger-zone">
        <h2>${esc(ui.settingsDangerZone)}</h2>
        <p>${esc(ui.settingsDangerZoneBody)}</p>
        <button type="button" class="settings-delete">${esc(ui.settingsDeleteAccountCta)}</button>
      </section>
    </div>
  `;

  root
    .querySelector<HTMLButtonElement>(".settings-back")
    ?.addEventListener("click", ctx.onBackHome);
  root
    .querySelector<HTMLButtonElement>(".settings-delete")
    ?.addEventListener("click", ctx.onDeleteAccountClick);
}
